module.exports = __webpack_public_path__ + "img/onedrive.cc38d634.svg";